import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforOutBound_GetOff {
  lockLengthWidthHeight:Boolean
  errorMessage:string //错误信息
  autoCreateCarCode:boolean //是否自动生成车签
  lockedCarSignNumShow:boolean //车签锁定框能否点击
  generationTimeOfAutoCreateCarCode: string//自动生成车签的时间
  carCodeOfAutoCreateCarCode: string//自动生成车签的时间
  numberInCar:number//应扫件数

  noReadLablel: number //无读数量
  noLittleNoLabel:number //无格口
  overTimeLabel:string //超时无格口
  manyCodeLabel:number //多条码
  LittleNoLabel:number //有格口

  isSixScanMode:boolean//是否是六面扫模式
}

@Module({ dynamic: true, store, name: 'store_scanforoutbound_getoff' })
class ScanforOutBound_GetOff extends VuexModule implements IScanforOutBound_GetOff {
  public lockLengthWidthHeight = false;
  public errorMessage = "";
  public autoCreateCarCode = false;
  public lockedCarSignNumShow = false;
  public generationTimeOfAutoCreateCarCode = "";
  public carCodeOfAutoCreateCarCode = "";
  public numberInCar = 0;

  public noReadLablel = 0;
  public noLittleNoLabel = 0;
  public overTimeLabel = "0";
  public manyCodeLabel = 0;
  public LittleNoLabel = 0;
  public isSixScanMode = false;

  @Mutation
  public setLockLengthWidthHeight(state) {
    this.lockLengthWidthHeight = state;
  }

  @Mutation
  public setErrorMessage(str) {
    this.errorMessage = str;
  }

  @Mutation
  public setAutoCreateCarCode(boolValue) {
    this.autoCreateCarCode = boolValue;
  }

  @Mutation
  public setLockedCarSignNumShow(showValue) {
    this.lockedCarSignNumShow = showValue;
  }

  @Mutation
  public setAutoCreateCarCodeDataAndCode(payload: { carCode: string, dateStr: string } | null) {
    const { carCode = "", dateStr= ""  } = payload || {}
    this.carCodeOfAutoCreateCarCode = carCode;
    this.generationTimeOfAutoCreateCarCode = dateStr;
  }

  @Mutation
  public setNumberInCarValue(value) {
    this.numberInCar = value;
  }

  @Mutation
  public setNoReadLablel(num) {
    this.noReadLablel = num;
  }
  @Mutation
  public setNoLittleNoLabel(num) {
    this.noLittleNoLabel = num;
  }
  @Mutation
  public setOverTimeLabel(num) {
    this.overTimeLabel = num;
  }
  @Mutation
  public setManyCodeLabel(num) {
    this.manyCodeLabel = num;
  }
  @Mutation
  public setLittleNoLabel(num) {
    this.LittleNoLabel = num;
  }

  @Mutation
  public setSixScanState(num) {
    this.isSixScanMode = num;
  }

}

export const ScanforOutBound_GetOffModule = getModule(ScanforOutBound_GetOff)
